import axios from 'axios';
import { baseUrl, token } from '../../services/Apis';

export const CARNET_CONST = 'carnet';
export const carnet_api = `${baseUrl}/${CARNET_CONST}`;

export const allCarnetService = async (params) => {
  const res = await axios.get(carnet_api, {
    headers: token({}),
    params,
  });
  return res;
};

export const saveCarnetService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(`${carnet_api}/${id}`, data, {
      headers: token({}),
    });
  } else {
    res = await axios.post(carnet_api, data, {
      headers: token({}),
    });
  }
  return res;
};

export const oneCarnetService = async (id) => {
  const res = await axios.get(`${carnet_api}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const deleteCarnetService = async (id) => {
  const res = await axios.delete(`${carnet_api}/${id}`, {
    headers: token({}),
  });
  return res;
};
